import React, { useEffect, useState } from "react"
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Spinner } from 'reactstrap';
import classes from './RemainderMessageModal.module.scss';
import { boxiPrimary } from "../../../../assets/style/colors";
import { Checkbox, Paper, Skeleton, Grid, Card, CardHeader, Avatar, IconButton, Chip, CardActionArea, FormControl, InputLabel, OutlinedInput, InputAdornment, Tooltip, ListItemText } from "@mui/material";
import axios from "axios";
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { toast } from "react-toastify";
import DescriptionIcon from '@mui/icons-material/Description';
import Templates from "../Templates/Templates";
import SearchIcon from '@mui/icons-material/Search';
import _ from 'lodash';

const config = {
    headers: {
        "Content-Type": "application/json"
    },
    withCredentials: true
};

const reminderTemplate =  `Hello! Could you please send pictures of the following truck/s:

- License Plate: <License Plate #>, Active Campaign: <Name of Campaign>
- License Plate: <License Plate #>, Active Campaign: <Name of Campaign>

Thank you and have a great day!`

const RemainderMessageModal = ({ isModalOpen, openModal }) => {
    const [vendorList, setVendorList] = useState([])
    const [filteredVendorList, setFilteredVendorList] = useState([])
    const [vendorListLoading, setVendorListLoading] = useState(true)
    const [messageSending, setMessageSending] = useState(false)
    const [defaultTab, setDefaultTab] = useState(0)
    const [messageInputValue, setMessageInputValue] = useState('')
    const [isTemplateModalOpen, setIsTemplateModalOpen] = useState(false)
    const [templateSelectionType, setTemplateSelectionType] = useState(null);
    const [templateForMessage, setTemplateForMessage] = useState(null);
    const [allSelected, setAllSelected] = useState(false)
    const [searchInput, setSearchValue] = useState(null)
    const [remindersListSearchInput, setRemindersListSearchInput] = useState(null)
    const [isSearching, setIsSearching] = useState(false)
    const [remindersList, setRemindersList] = useState([]);
    const [originalRemindersList, setOriginalRemindersList] = useState([]);

    useEffect(() => {
        getAllPicturesVendor()
        return () => {
            setVendorList([])
            setFilteredVendorList([])
            setVendorListLoading(false)
            setDefaultTab(0)
            setMessageInputValue('')
            setIsTemplateModalOpen(false)
            setTemplateSelectionType(null)
            setTemplateForMessage()
            setAllSelected(false)
            setSearchValue(null)
        }
    }, [])

    const debouncedHandler = _.debounce(async (value) => {
        setVendorListLoading(true);
      
        let filtered = [];
      
        if (value !== '' && vendorList.length > 0) {
          filtered = vendorList.filter((item) =>
            item['vendor_name'].toLowerCase().indexOf(value.toLowerCase()) > -1 ||
            formatPhoneNumberToE164(item['vendor_num']).indexOf(value) > -1 ||
            item['campaign_display_names'].toLowerCase().indexOf(value.toLowerCase()) > -1
          );
        }
      
        if (filtered.length === 0 && value !== '' && filteredVendorList.length > 0) {
          filtered = filteredVendorList.filter((item) =>
            item['vendor_name'].toLowerCase().indexOf(value.toLowerCase()) > -1 ||
            formatPhoneNumberToE164(item['vendor_num']).indexOf(value) > -1 ||
            item['campaign_display_names'].toLowerCase().indexOf(value.toLowerCase()) > -1
          );
        }
      
        // Set the filtered list, or use filteredVendorList if no results
        if(value !== ''){
            setVendorList(filtered.length > 0 ? filtered : []);
        }else {
            setVendorList(filteredVendorList)
        }
        setVendorListLoading(false);
      }, 1000);

    const reminderListDebounceHandler = (value) => {
        let filtered = [];
        
        if (value !== '' && remindersList.length > 0) {
            filtered = remindersList.filter((item) =>
                item['vendor_name'].toLowerCase().indexOf(value.toLowerCase()) > -1 ||
                formatPhoneNumberToE164(item['phone_number']).indexOf(value) > -1
            );
            console.log("🚀 ~ filtered:", filtered)
        }
        
        if (filtered.length === 0 && value !== '' && originalRemindersList.length > 0) {
            filtered = originalRemindersList.filter((item) =>
                item['vendor_name'].toLowerCase().indexOf(value.toLowerCase()) > -1 ||
                formatPhoneNumberToE164(item['phone_number']).indexOf(value) > -1
            );
            console.log("🚀 ~ filtered:", filtered)
        }
        
        // Set the filtered list, or use originalRemindersList if no results
        if(value !== ''){
            setRemindersList(filtered.length > 0 ? filtered : []);
        }else {
            setRemindersList(originalRemindersList)
        }
    };

    useEffect(() => {
        console.log(templateForMessage);
        if (templateForMessage && templateForMessage.template_body.length > 0) setMessageInputValue(templateForMessage.template_body)
    }, [templateForMessage])

    const selectVendorHandler = (phoneNum, check, vendor_id) => {
        setVendorList(prevVendorList => {
            const updatedList = prevVendorList.map(row => {
                if (row.phone_num === phoneNum && row.vendor_id === vendor_id) {
                    return { ...row, check };
                }
                return row;
            });

            if (updatedList.map(v => v.check === 1).filter(v => v).length === updatedList.length) setAllSelected(true);
            else setAllSelected(false);

            return updatedList;
        });
    };

    const selectAllVendors = () => {
        setVendorList(prevVendorList => {
            const updatedList = prevVendorList.map(row => {
                return { ...row, check: 1 };
            });

            return updatedList;
        });
        setAllSelected(true)
    };

    const deselectAllVendors = () => {
        setVendorList(prevVendorList => {
            const updatedList = prevVendorList.map(row => {
                return { ...row, check: 0 };
            });
            return updatedList;
        });
        setAllSelected(false)
    };


    const handleDeleteChip = (vendorToDelete) => {
        setVendorList(prevVendorList => {
            const updatedList = prevVendorList.map(row => {
                if (row.vendor_id === vendorToDelete.vendor_id) {
                    return { ...row, check: 0 };
                }
                return row;
            });

            if (updatedList.map(v => v.check === 1).filter(v => v).length === updatedList.length) setAllSelected(true);
            else setAllSelected(false);
            return updatedList;
        });
    };


    const generateAvatarBackgroundColor = (name) => {
        let numericValue = 0;
        for (let i = 0; i < name.length; i++) {
            numericValue += name.charCodeAt(i);
        }
        const hue = numericValue % 360; // Use modulo to restrict the hue to a range of 0-359
        const saturation = 70; // Set a fixed saturation value
        const lightness = 50; // Set a fixed lightness value
        const color = `hsl(${hue}, ${saturation}%, ${lightness}%)`;
        return color;
    };

    const getAllPicturesVendor = async () => {
        let res = await axios.get(`${process.env.REACT_APP_API_HOST}/comunication/get-picture-vendors-for-remainder`, config);
        if (res?.data?.reminder_list?.length > 0) {
            let reminderCheckList = res.data.reminder_list.map(item => ({
                ...item, check: 0
            }))
            console.log('reminder data: ', reminderCheckList);
            setVendorList([...reminderCheckList])
            setFilteredVendorList([...reminderCheckList])
            setVendorListLoading(false)
        } else {
            setVendorList([])
            setFilteredVendorList([])
            setVendorListLoading(false)
        }
    }

    const sendSMS = async () => {
        let vendorsSelectedToSend = vendorList.filter((item) => {
            return item.check === 1;
        })
        try {
            setMessageSending(true);
            for (const reminder of remindersList) {
                const body = {
                    to: formatPhoneNumberToE164(reminder.phone_number),
                    body: reminder.message_body, 
                    sender_id: JSON.parse(localStorage.getItem("userId")),
                    isPictures: false
                }
                const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/send`, body)
                if (res.status === 200) {
                    await getAllPicturesVendor()
                    toast.success('message sent successfully')
                }
            }
            setTimeout(() => {
                getAllPicturesVendor()
                setMessageSending(false);
                setVendorListLoading(false)
                setDefaultTab(0)
                setMessageInputValue('')
                setIsTemplateModalOpen(false)
                setTemplateSelectionType(null)
                setTemplateForMessage()
                setAllSelected(false)
                setRemindersList([])
                setOriginalRemindersList([])
            }, 1000);
        } catch (error) {
            getAllPicturesVendor()
            setMessageSending(false);
            setVendorListLoading(false)
            setDefaultTab(0)
            setMessageInputValue('')
            setIsTemplateModalOpen(false)
            setTemplateSelectionType(null)
            setTemplateForMessage()
            setAllSelected(false)
        }
    }

    // async function sendSMS() {
    //     try {
    //         setMessageSending(true);
    //         const smsPromises = [];
        
    //         for (const reminder of remindersList) {
    //             try {
    //             const body = {
    //                 to: reminder.phone_number, 
    //                 body: reminder.message_body, 
    //                 sender_id: JSON.parse(localStorage.getItem("userId")),
    //                 isPictures: false
    //             }

    //             const res = await axios.post(`${process.env.REACT_APP_API_HOST}/communication/send`, body)
    //             // setMessagesSent((prev) => prev + 1);
    //             // setSuccessMessages((prev) => [...prev, phone_number]);
    //             smsPromises.push({ status: 'fulfilled', phone_number: reminder.phone_number, response: res });
    //             } catch (error) {
    //             console.error(`Failed to send SMS to ${reminder.phone_number}:`, error);
    //             // setFailedMessages((prev) => [...prev, reminder.phone_number]);
    //             smsPromises.push({ status: 'rejected', phone_number: reminder.phone_number, reason: error });
    //             }
    //         }
        
    //         const results = await Promise.allSettled(smsPromises);
        
    //         // Handle the results, including both fulfilled and rejected promises
    //         results.forEach((result) => {
    //             if (result.status === 'fulfilled') {
    //             // Handle successful SMS
    //             } else if (result.status === 'rejected') {
    //             // Handle failed SMS
    //             const { phone_number, reason } = result;
    //             console.log(`Failed to send SMS to ${phone_number}`);
    //             }
    //         });
        
    //         setTimeout(() => {
    //             getAllPicturesVendor()
    //             setMessageSending(false);
    //             setVendorListLoading(false)
    //             setDefaultTab(0)
    //             setMessageInputValue('')
    //             setIsTemplateModalOpen(false)
    //             setTemplateSelectionType(null)
    //             setTemplateForMessage()
    //             setAllSelected(false)
    //         }, 1000);
    //     } catch (error) {
    //       console.error(error);
    //       getAllPicturesVendor()
    //         setMessageSending(false);
    //         setVendorListLoading(false)
    //         setDefaultTab(0)
    //         setMessageInputValue('')
    //         setIsTemplateModalOpen(false)
    //         setTemplateSelectionType(null)
    //         setTemplateForMessage()
    //         setAllSelected(false)
    //     }
    //   }

    // with updated changes
    const formatPhoneNumberToE164 = (phoneNumber) => {
        if (phoneNumber !== '' && phoneNumber !== null) {
            const numericPhoneNumber = phoneNumber?.replace(/\D/g, '');
            return numericPhoneNumber?.length === 10 ? `+1${numericPhoneNumber}` : `+${numericPhoneNumber}`;
        }
    }

    function SkeletonGrid() {
        const skeletonRows = Array.from({ length: 2 }, (_, index) => (
            <Grid item xs={6} key={index}>
                <Skeleton variant="rectangular" width={367} height={98} style={{ borderRadius: '4px' }} />
            </Grid>
        ));

        return (
            <Grid container spacing={2}>
                {skeletonRows}
            </Grid>
        );
    }


    const checkedPhoneNumbers = vendorList
        .filter(vendor => vendor.check === 1)
        .map((vendor, index) => {
            return (
                <Chip
                    key={index}
                    label={vendor.vendor_name}
                    onDelete={() => handleDeleteChip(vendor)}
                />
            );
        });

    useEffect(() => {
        if (defaultTab == 1) {
            const reminders = []
            const selectedVendorsForReminders = vendorList.filter(vendor => vendor.check === 1);
            selectedVendorsForReminders.forEach(vendor => {
                const reminderData = vendor.reminders.split(' | ').filter(val => val !== '')
                let truckDetails = ``
                reminderData.forEach(reminder => {
                    const reminderDetails = reminder.split(', ')
                    truckDetails += `\n- License Plate: ${reminderDetails[1]}, Active Campaign: ${reminderDetails[2]}`
                })
                const body = {
                    vendor_name: vendor.vendor_name,
                    vendor_id: vendor.vendor_id,
                    phone_number: vendor.vendor_num,
                    message_body: `Hello! Could you please send pictures of the following truck/s:\n` + truckDetails + `\n\nThank you and have a great day!`
                }
                reminders.push(body)
            })
            setRemindersList(reminders);
            setOriginalRemindersList(reminders);
        }
    }, [defaultTab])

    return (
        <Modal backdrop="static" className={classes.modalDialog} isOpen={isModalOpen}>
            <ModalHeader >Send Custom Reminder</ModalHeader>
            <ModalBody style={{ position: 'relative' }}>
                {defaultTab === 0 ? (
                    <div className={classes.wrapper}>
                        {vendorListLoading &&
                            (
                                <>
                                    <FormControl fullWidth sx={{ m: 1 }}>
                                        <InputLabel htmlFor="outlined-adornment-search">Search</InputLabel>
                                        <OutlinedInput
                                            id="outlined-adornment-search"
                                            startAdornment={<InputAdornment position="start"><SearchIcon /></InputAdornment>}
                                            label="search"
                                            disabled={true}
                                        />
                                    </FormControl>
                                    <SkeletonGrid />
                                </>
                            )}
                        {!vendorListLoading && vendorList.length > 0 && (
                            <>
                                <FormControl fullWidth sx={{ m: 1 }}>
                                    <InputLabel htmlFor="outlined-adornment-search">Search</InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-search"
                                        startAdornment={<InputAdornment position="start"><SearchIcon /></InputAdornment>}
                                        label="Search"
                                        disabled={vendorListLoading}
                                        value={searchInput}
                                        onChange={(e) => {
                                            setSearchValue(e.target.value)
                                            debouncedHandler(e.target.value)
                                        }}
                                    />
                                </FormControl>
                                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 22, width: '100%', borderRadius: '10px' }}>
                                    {vendorList.map((row) => (
                                        <div style={{ }} key={row.vendor_num}>
                                            <Card style={{
                                                backgroundColor: row.check === 1  ? '#e4a7c447' : ''
                                            }}
                                                onClick={() => {
                                                    selectVendorHandler(row.phone_num, row.check === 1 ? 0 : 1, row.vendor_id);
                                                }}
                                            >
                                                <CardActionArea>
                                                    <CardHeader
                                                        avatar={
                                                            <Avatar aria-label="recipe" style={{ backgroundColor: generateAvatarBackgroundColor(row.vendor_name) }}>
                                                                {row.vendor_name.trim().split(' ').slice(0, 2).reduce((acc, name) => acc + name[0], '')}
                                                            </Avatar>
                                                        }
                                                        title={<div className={'text-truncate'} style={{ maxWidth: 230 }}>
                                                            {row.vendor_name}
                                                        </div>
                                                        }
                                                        subheader={<div style={{
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            justifyContent: 'center',
                                                            alignItems: 'start',
                                                            maxWidth: '230px',
                                                            padding: 0
                                                        }}>
                                                            <div>
                                                                {formatPhoneNumberToE164(row.vendor_num)}
                                                            </div>
                                                            <Tooltip placement="top" title={row?.campaign_display_names}>
                                                                <ListItemText style={{
                                                                    fontSize: '12px'
                                                                }} id={row?.campaign_display_names} disableTypography={true} sx={{ fontFamily: 'Poppins', fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '88%' }} primary={row?.campaign_display_names} />
                                                            </Tooltip>
                                                        </div>}
                                                        action={
                                                            <IconButton
                                                                style={{ marginRight: '2px'}}
                                                                aria-label="toggle-checkbox"
                                                                onClick={(e) => {
                                                                    e.preventDefault();
                                                                    selectVendorHandler(row.phone_num, row.check === 1 ? 0 : 1, row.vendor_id);
                                                                }}
                                                            >
                                                                {row.check === 1 ? (
                                                                    <CheckCircleOutlineRoundedIcon
                                                                        style={{
                                                                            color: boxiPrimary,
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <RadioButtonUncheckedIcon
                                                                        style={{
                                                                            color: 'grey',
                                                                            cursor: 'pointer',
                                                                        }}
                                                                    />
                                                                )}
                                                            </IconButton>
                                                        }
                                                    />
                                                </CardActionArea>
                                            </Card>
                                        </div>
                                    ))}
                                </div>
                            </>
                        )}
                        {!vendorListLoading && vendorList.length === 0 && (
                            <>
                                <FormControl fullWidth sx={{ m: 1 }}>
                                    <InputLabel htmlFor="outlined-adornment-search">Search</InputLabel>
                                    <OutlinedInput
                                        id="outlined-adornment-search"
                                        startAdornment={<InputAdornment position="start"><SearchIcon /></InputAdornment>}
                                        label="Search"
                                        disabled={vendorListLoading}
                                        value={searchInput}
                                        onChange={(e) => {
                                            setSearchValue(e.target.value)
                                            debouncedHandler(e.target.value)
                                        }}
                                    />
                                </FormControl>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <div style={{ textAlign: 'center' }}>
                                            No vendors found!
                                        </div>
                                    </Grid>
                                </Grid>
                            </>
                        )}
                    </div>
                ) : (
                    <div className={classes.textAreaWrapper}>
                        {defaultTab === 1 ?
                            <div style={{ display: 'flex', alignItems: 'center', columnGap: 8 }}>
                                <span>Vendors:</span><div style={{ display: 'flex', alignItems: 'center', columnGap: 8, maxWidth: 700, overflow: 'auto' }}>{checkedPhoneNumbers}</div>
                            </div> : ''}
                        {/* <textarea
                            type="text"
                            className={`form-control ${classes.textArea}`}
                            value={reminderTemplate}
                            rows={10}
                            disabled={true}
                            style={{ resize: 'none', marginTop: '15px' }}
                        ></textarea> */}
                        <hr />
                        <div style={{ marginTop: 20 }}>Reminder Messages List:</div>
                        <hr />
                        <FormControl fullWidth sx={{ m: 1 }}>
                            <InputLabel htmlFor="outlined-adornment-search">Search</InputLabel>
                            <OutlinedInput
                                id="outlined-adornment-search"
                                startAdornment={<InputAdornment position="start"><SearchIcon /></InputAdornment>}
                                label="Search"
                                value={remindersListSearchInput}
                                onChange={(e) => {
                                    setRemindersListSearchInput(e.target.value)
                                    reminderListDebounceHandler(e.target.value)
                                }}
                            />
                        </FormControl>
                        <div style={{ maxHeight: 350, overflow: 'auto' }}>
                            {remindersList && remindersList.map((reminder) => {
                                return (
                                    <>
                                        <div style={{ margin: "10px 0" }}>
                                            <div style={{ marginBottom: 4 }}><strong>Vendor Name: </strong>{reminder.vendor_name}</div>
                                            <div style={{ marginBottom: 4 }}><strong>Phone Number: </strong>{reminder.phone_number}</div>
                                            <div><strong>Message Body:</strong></div>
                                            <div dangerouslySetInnerHTML={{ __html: reminder.message_body.replace(/\n/g, '<br />') }}></div>
                                        </div>
                                        <hr />
                                    </>
                                )
                            })}
                        </div>
                    </div>
                )}
                {isTemplateModalOpen && <Templates openModal={setIsTemplateModalOpen} isModalOpen={isTemplateModalOpen} type={templateSelectionType} setTemplateForMessage={setTemplateForMessage} />}
            </ModalBody>
            <ModalFooter style={{ display: 'flex', justifyContent: `${vendorList.length > 0 ? 'space-between' : 'flex-end'}`, alignItems: 'center' }}>
                {vendorList.length > 0 && (
                    <div>
                        {defaultTab === 0 ?
                            <Button color={"primary"} onClick={() => {
                                if (allSelected) {
                                    deselectAllVendors()
                                } else {
                                    selectAllVendors()
                                }
                            }}>
                                {allSelected ? 'Deselect All' : 'Select All'}
                            </Button> :
                            <Button color={"primary"} onClick={() => {
                                setDefaultTab(0)
                            }}>
                                {'Go Back'}
                            </Button>}
                    </div>
                )}
                <div style={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '10px'
                }}>
                    {defaultTab === 0 ? (
                        <Button disabled={!messageSending && vendorList?.every(item => !item.check)} color={messageSending ? "secondary" : "primary"} onClick={() => setDefaultTab(1)}>
                            {'Next'}
                        </Button>
                    ) : (
                        <Button disabled={!messageSending && vendorList?.every(item => !item.check)} color={messageSending ? "secondary" : "primary"} onClick={() => sendSMS()}>
                            {messageSending ? 'Sending reminder' : 'Send Reminder'}
                        </Button>
                    )}
                    <Button color="secondary" onClick={() => openModal(false)}>
                        Close
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    )
}

export default RemainderMessageModal